import setCssMediaQuery from 'helpers/setCssMediaQuery';

const hashFormStyling = new Map();


export default function mixFormStyling(styling, typeOfStyle, viewPort, thisWindow) {

  if (!styling) return;

  let inputFilteredStyling = {};
  let placeholderFilteredStyling = {};
  let counterFilteredStyling = {};
  let bulletFilteredStyling = {};
  let checkboxFilteredStyling = {};

  const keyHash = JSON.stringify(styling)+typeOfStyle+viewPort;

  const getStylingHash = hashFormStyling.get(keyHash);
  if (getStylingHash) return getStylingHash;

  if (styling) {
    for (const [componentItem, componentStyling] of Object.entries(styling)) {

      const inputStyling = {};
      const placeholderStyling = {};
      const counterStyling = {};
      const bulletStyling = {};
      const checkboxStyling = {};
      
      for (const [viewPort, viewPortStyling] of Object.entries(componentStyling)) {

        inputStyling[viewPort] = {};
        placeholderStyling[viewPort] = {};
        counterStyling[viewPort] = {};
        bulletStyling[viewPort] = {};
        checkboxStyling[viewPort] = {};

        for (const [key, styles] of Object.entries(viewPortStyling)) {
          if (key.startsWith('input_')) inputStyling[viewPort][key.replace('input_', '')] = styles;
          if (key.startsWith('placeholder_')) placeholderStyling[viewPort][key.replace('placeholder_', '')] = styles;
          if (key.startsWith('counter_')) counterStyling[viewPort][key.replace('counter_', '')] = styles;
          if (key.startsWith('bullet_')) bulletStyling[viewPort][key.replace('bullet_', '')] = styles;
          if (key.startsWith('checkbox_')) checkboxStyling[viewPort][key.replace('checkbox_', '')] = styles;
        }
      }

      inputFilteredStyling[componentItem] = inputStyling;
      placeholderFilteredStyling[componentItem] = placeholderStyling;
      counterFilteredStyling[componentItem] = counterStyling;
      bulletFilteredStyling[componentItem] = bulletStyling;
      checkboxFilteredStyling[componentItem] = checkboxStyling;
    }

  }


  const hashPayload = {
    formMixStyles: setCssMediaQuery(inputFilteredStyling, typeOfStyle, viewPort, thisWindow),
    placeholderMixStyles: setCssMediaQuery(placeholderFilteredStyling, typeOfStyle, viewPort, thisWindow),
    counterMixStyles: setCssMediaQuery(counterFilteredStyling, typeOfStyle, viewPort, thisWindow),
    bulletMixStyles: setCssMediaQuery(bulletFilteredStyling, typeOfStyle, viewPort, thisWindow),
    checkboxMixStyles: setCssMediaQuery(checkboxFilteredStyling, typeOfStyle, viewPort, thisWindow),
  };

  hashFormStyling.set(keyHash, hashPayload);
  return hashPayload;

}



